export const AppConfig = {
  // ======================
  // API
  // ======================
  apiUrl: process.env.VUE_APP_API_URL!,
  authApiUrl: process.env.VUE_APP_AUTH_API_URL!,

  // ======================
  // STT
  // ======================
  sttApiUrl: process.env.VUE_APP_STT_API_URL!,
  webSocketUrl: process.env.VUE_APP_SOCKET_URL!,

  // ======================
  // Apple Login
  // ======================
  appleLogin: {
    clientId: process.env.VUE_APP_APPLE_CLIENT_ID!,
    redirectURI: process.env.VUE_APP_APPLE_REDIRECT_URI!,
  },

  // ======================
  // Google Login
  // ======================
  googleLogin: {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID!,
  },

  // ======================
  // System account (optional)
  // ======================
  apiUsername: process.env.VUE_APP_API_USERNAME,
  apiPassword: process.env.VUE_APP_API_PASSWORD,
}